import React, { useEffect, useRef } from 'react';
import api from 'lib/api';
import Modal from 'containers/Modals/Modal';
import { LTIComponent } from 'containers/LTI';
import { useTranslate } from 'lib/translate';

var NDLAFrame = function NDLAFrame(props) {
  var translate = useTranslate();
  var iframeElement = useRef();

  var handleResize = function handleResize() {
    if (iframeElement.current == null) {
      return false;
    }

    iframeElement.current.style.height = window.outerHeight - 295 + 'px';
  };

  var addResource = function addResource(values) {
    var id = values.url.replace(/^\D+/g, '');
    api.get("https://api.ndla.no/article-api/v2/articles/".concat(id)).then(function (_ref) {
      var data = _ref.data;
      props.toggleModal();
      props.onSubmit({
        url: values.url,
        title: data.title.title,
        introduction: data.introduction.introduction,
        id: data.id,
        articleType: data.articleType,
        revision: data.revision,
        revisionDate: data.revisionDate,
        updated: data.updated,
        metaImageUrl: data.metaImage.url,
        metaImageAlt: data.metaImage.alt
      });
    })["catch"](function (reason) {
      props.toggleModal();
      console.error('could not fetch article data because', reason);
    });
  };

  useEffect(function () {
    handleResize();
    window.addEventListener('resize', handleResize);
    var interval = setInterval(function () {
      if (iframeElement.current != null) {
        handleResize();
        clearInterval(interval);
      }
    }, 150);
    return function () {
      window.removeEventListener('resize', handleResize);
      clearInterval(interval);
    };
  }, []);
  handleResize();
  return /*#__PURE__*/React.createElement(Modal, {
    title: translate('NDLA'),
    isOpen: props.isOpen,
    onClose: props.toggleModal
  }, /*#__PURE__*/React.createElement("div", {
    className: "block--ndla-block iframe-container"
  }, /*#__PURE__*/React.createElement(LTIComponent, {
    source: "https://ndla.no/lti",
    ref: iframeElement,
    onCallback: addResource
  })));
};

NDLAFrame.defaultProps = {
  onSubmit: function onSubmit() {
    return true;
  },
  toggleModal: function toggleModal() {
    return true;
  },
  isOpen: true
};
export default NDLAFrame;